export default [
	{	path: "/reflections/",
		component: () => import("../views/Reflections/Dashboard.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: '/reflections/view/:activityId',
		component: () => import('../views/Reflections/ViewActivity.vue'),
	},
	{	path: "/reflections/save/:activityId",
		component: () => import("../views/Reflections/SaveActivity.vue"),
	},
	{	path: "/reflections/newdops",
		component: () => import("../views/Reflections/NewDops.vue"),
	},
	{	path: "/reflections/newsignoff",
		component: () => import("../views/Reflections/NewSignoff.vue"),
	},
	{	path: "/reflection-log/",
		component: () => import("../views/ReflectionLog/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
]
